import { useSelector } from 'react-redux'
import { Container, Row, Col } from 'reactstrap'
import { ContactDetails } from './ContactDetails'
import { ProfileInfoSection } from './ProfileInfoSection'
import { ContactTabs } from './ContactTabs'
import { ContactSidebar } from './ContactSidebar'
import s from './Contact.scss'

const Contact = ({ contact, roles, deals, proposals, pipeline, companyDeals, companyPipeline }) => {
  const sidebar = useSelector(state => state.sidebar)
  const isSidebarOpen = sidebar.contactSidebar.isOpen

  const { photo, company } = contact
  return (
    <section>
      <Container className={s.container}>
        <Row>
          <Col lg={isSidebarOpen ? '2' : '3'} className={s.left}>
            <ProfileInfoSection photo={photo} pipeline={pipeline} proposalsNo={proposals.length} />
          </Col>
          <Col lg={isSidebarOpen ? '7' : '9'} className={s.main}>
            <ContactDetails contact={contact} roles={roles} deals={deals} />
            <ContactTabs contact={contact} />
          </Col>
          {isSidebarOpen ? (
            <Col lg="3" className={s.sidebar}>
              <ContactSidebar
                company={company}
                companyDeals={companyDeals}
                companyPipeline={companyPipeline}
              />
            </Col>
          ) : (
            <div className={s.sidebarCollapsed}>
              <ContactSidebar
                company={company}
                companyDeals={companyDeals}
                companyPipeline={companyPipeline}
              />
            </div>
          )}
        </Row>
      </Container>
    </section>
  )
}

export default Contact
